import { render, staticRenderFns } from "./SupplyDocument.vue?vue&type=template&id=1836db9c&scoped=true&"
import script from "./SupplyDocument.vue?vue&type=script&lang=js&"
export * from "./SupplyDocument.vue?vue&type=script&lang=js&"
import style0 from "./SupplyDocument.vue?vue&type=style&index=0&id=1836db9c&lang=scss&scoped=true&"
import style1 from "./SupplyDocument.vue?vue&type=style&index=1&id=1836db9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836db9c",
  null
  
)

export default component.exports